export const images = [
  'https://360ra.com/wp-content/uploads/2019/04/360RACS-Product.jpg',
  'https://360ra.com/wp-content/uploads/2019/04/Screen-Shot-2021-01-05-at-7.08.17-PM.png',
  'https://360ra.com/wp-content/uploads/2019/04/Screen-Shot-2021-01-05-at-7.10.43-PM.png',
  'https://360ra.com/wp-content/uploads/2019/04/Screen-Shot-2021-01-05-at-7.13.07-PM.png',
];
